export const cls = (...arr: (string | undefined | boolean)[]) => {
  return [...arr].filter((i) => !!i).join(' ');
};
